/** Public demo cabinet at demo.provisium.ru — real API, cloned anonymized tenant. */
export const isDemoStandEnabled = (): boolean => import.meta.env.VITE_DEMO_STAND === 'true'

export const DEMO_STAND_EMAIL = import.meta.env.VITE_DEMO_STAND_EMAIL || 'demo@provisium.ru'

export const DEMO_STAND_PASSWORD = import.meta.env.VITE_DEMO_STAND_PASSWORD || 'ProvisiumDemo30!'

export const DEMO_STAND_REGISTER_URL =
  import.meta.env.VITE_DEMO_STAND_REGISTER_URL ||
  'https://market.provisium.ru/register?plan=start'
